var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOnboarding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69832",
    "data-name": "Group 69832",
    transform: "translate(5036 -11161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15581",
    "data-name": "Group 15581",
    transform: "translate(-5060 11009)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69833",
    "data-name": "Group 69833",
    transform: "translate(-5023.007 10014.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67615",
    "data-name": "Path 67615",
    d: "M4.751,1159v2.49H-2.612v17.789H4.751v2.278H21.94V1159Zm0,18.559H-.894v-14.351H4.751Zm15.469,2.278H6.471v-19.118h13.75Z",
    fill: "#767493"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67616",
    "data-name": "Path 67616",
    d: "M16.3,1177.109a5.2,5.2,0,1,0-5.2-5.2,5.2,5.2,0,0,0,5.2,5.2Zm-1.525-6.164,1.019,1.022,2.038-2.041,1.02,1.022-3.059,3.058-2.038-2.039Z",
    transform: "translate(-2.817 -1.586)",
    fill: "#767493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnboarding);
export default __webpack_public_path__ + "static/media/icon_onboarding.f8a71aa09c2ba9b5315404b7c59ce073.svg";
export { ForwardRef as ReactComponent };